var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIdm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.654,
    height: 11.814,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_250",
    "data-name": "Rectangle 250",
    className: "cls-1",
    d: "M0 0h20.654v11.814H0z"
  })), /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:currentColor}"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_128",
    "data-name": "Group 128"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_127",
    "data-name": "Group 127",
    style: {
      clipPath: "url(#clip-path2)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    className: "cls-1",
    d: "M18.313 6.247a2.511 2.511 0 1 0-3.12 0 3.9 3.9 0 0 0-1.363.982 5.419 5.419 0 0 0-1.63-.941 3.423 3.423 0 1 0-3.737 0 5.425 5.425 0 0 0-1.639.954 3.9 3.9 0 0 0-1.365-.99 2.511 2.511 0 1 0-3.119 0A3.908 3.908 0 0 0 0 9.822a.436.436 0 0 0 .873 0A3.029 3.029 0 0 1 3.819 6.8c.029 0 .055.008.084.008s.07-.009.105-.011a3.038 3.038 0 0 1 2.2 1.062 5.4 5.4 0 0 0-1.3 3.518.436.436 0 0 0 .873 0 4.557 4.557 0 0 1 4.31-4.543c.082.006.163.012.246.012s.164-.007.246-.012a4.558 4.558 0 0 1 4.31 4.543.436.436 0 0 0 .872 0 5.4 5.4 0 0 0-1.309-3.526 3.026 3.026 0 0 1 2.19-1.051c.036 0 .069.011.105.011s.055-.007.084-.008a3.029 3.029 0 0 1 2.947 3.022.436.436 0 0 0 .872 0 3.908 3.908 0 0 0-2.341-3.575M2.265 4.3a1.638 1.638 0 1 1 1.743 1.625c-.035 0-.07-.006-.105-.006s-.075 0-.112.006A1.636 1.636 0 0 1 2.265 4.3m5.517-.875A2.551 2.551 0 1 1 10.5 5.958c-.055 0-.109-.009-.164-.009s-.109.007-.164.009a2.547 2.547 0 0 1-2.39-2.535m7.331.875a1.638 1.638 0 1 1 1.751 1.627c-.037 0-.074-.006-.112-.006s-.07 0-.105.006A1.635 1.635 0 0 1 15.112 4.3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdm);
export default __webpack_public_path__ + "static/media/idm.1a28bea3c4c5a82f7584a0a7d127060a.svg";
export { ForwardRef as ReactComponent };